import { AddressExemptionCheckbox } from '@components'

import { ReactElement, useCallback } from 'react'

import { useUpdateAddressExemption } from '../../../../hooks/useUpdateAddressExemption'
import { useCustomerForm } from '../../contexts/customerFormContext'
import { useUpdateDependentCustomerFormValues } from '../../hooks/useUpdateDependentCustomerFormValues'

export const AddressExemption = (): ReactElement => {
  const { customerForm } = useCustomerForm()
  const { FormItem, setValue } = customerForm
  const { updateAddressExemption } = useUpdateAddressExemption({ setValue })
  const { handleAddressSync } = useUpdateDependentCustomerFormValues()

  const handleAddressExemptionChange = useCallback(
    (isAddressExempt: boolean) => {
      updateAddressExemption(isAddressExempt)

      if (isAddressExempt) {
        handleAddressSync(undefined)
      }
    },
    [handleAddressSync, updateAddressExemption],
  )

  return (
    <FormItem
      name="isAddressExempt"
      render={({ field: { value } }) => (
        <AddressExemptionCheckbox checked={value} onChange={handleAddressExemptionChange} />
      )}
    />
  )
}
